module.exports = __webpack_public_path__ + "img/yunying.14da78a5.png";